
  import {Component, Prop, Vue} from 'vue-property-decorator';
  import PhoneInput from "@/components/PhoneInput.vue";
  import {IParkEvent} from "@/modules/ParksConfig/interfaces/park-event.interface";
  import {IApp} from "@/interfaces/app.interface";

  @Component({
    components: {
      PhoneInput,
    },
  })
  export default class ParkEventCell extends Vue {
    @Prop() rowData: IParkEvent.IEntity;
    @Prop() value: string;
    @Prop() index: number;
    @Prop() cell: IParkEvent.ITableCell;
    @Prop() active: boolean;
    @Prop() errorProps: string[];

    $refs: any;
    publicPath = process.env.VUE_APP_PUBLIC_URL;
    propType = IParkEvent.PropType;
    dateFormat = 'DD.MM.YYYY HH:mm';
    displayPassword = false;
    dateFormats = IApp.DateFormats;
    pickerOptions = IApp.DatePickerOptions.Simple;

    get selectValueMultiple() { return this.value ? this.value.split(',').map(item => +item) : []; }
    get selectValue() { return +this.value; }

    get dateValue() { return this.value; }
    set dateValue(value: string) { this.$emit('input', value); }

    inputAction(value) {
      let resultValue = value;
      if (this.cell.prop === 'phone' && ['+7 (', '+7 '].includes(value)) resultValue = null;
      this.$emit('input', resultValue);
    }

    generatePassword() {
      let password = "";
      // const symbols = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_";
      const symbols = "0123456789";
      for (let i = 0; i < 6; i++){
        password += symbols.charAt(Math.floor(Math.random() * symbols.length));
      }
      this.inputAction(password);
    }
  }
